module.exports = __webpack_public_path__ + "Kevin Shao-a0b0c1a7.png";